import { getDebugRing } from '@lib/devUtils';
import { clx } from '@lib/utils';

interface IAddNoteProps {
  className?: string;
  noteText: string;
  setNoteText: (noteText: string) => void;
}
export const AddNote = ({ className, noteText, setNoteText }: IAddNoteProps) => {
  const maxLength = 100;

  return (
    <div className={clx('w-full flex-1', className)}>
      {/* Instructions */}
      <h1 className={clx('mb-4 text-center text-lg text-black', getDebugRing('orange'))}>
        Add a note - if it feels right:
      </h1>

      {/* Note input */}
      <div className={clx('mx-auto w-10/12', getDebugRing('purple'))}>
        <div className="relative">
          <textarea
            className="bg-background-tertiary w-full resize-none rounded-2xl border border-black p-2"
            rows={4}
            name="note"
            maxLength={maxLength}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            // placeholder="Share what's on your mind..."
          />
          <div className="absolute bottom-2 right-2 text-xs opacity-50">
            {noteText.length}/{maxLength}
          </div>
        </div>
      </div>
    </div>
  );
};
